<template>
  <div :id="id ? id : undefined" :class="classes">
    <div class="inner">
      <div class="heading-wrap">
        <RoundIcon :icon="icon" theme="dark" size="md" icon-style="circle" />

        <Heading
          v-if="heading"
          :content="heading"
          role="headline"
          size="small"
          tag="h3"
          :status="headingStatus"
        />
      </div>

      <div class="cta-wrap">
        <div :class="verticalAlignClass">
          <p v-if="paragraph">
            <span v-html="paragraph"></span>
          </p>
          &nbsp;
          <InfoButton v-if="paragraphPopover" :content="paragraphPopover" />
        </div>

        <LinkButton
          v-if="buttonContent"
          :button-type="buttonStyle"
          class="cta"
          :url="buttonLink"
          :class="buttonCustomClass"
          :target="buttonTarget"
          >{{ buttonContent }}</LinkButton
        >

        <div v-if="secondParagraph || secondButtonContent" class="second">
          <p v-if="secondParagraph">
            <span v-html="secondParagraph"></span>
          </p>
          &nbsp;
          <InfoButton
            v-if="secondParagraphPopover"
            :content="secondParagraphPopover"
          />
        </div>

        <LinkButton
          v-if="secondButtonContent"
          class="cta"
          :url="secondButtonLink"
          :target="secondButtonTarget"
          :class="secondButtonCustomClass"
          :button-type="secondButtonStyle"
          >{{ secondButtonContent }}</LinkButton
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import './FooterContactItem.scss';
import RoundIcon from 'ewi-ui/components/2-molecules/RoundIcon';
import Heading from 'ewi-ui/components/1-atoms/Heading';
import LinkButton from 'ewi-ui/components/1-atoms/LinkButton';
//@ts-ignore
import InfoButton from 'ewi-ui/components/2-molecules/InfoButton/InfoButton.vue';
import { ButtonType } from 'ewi-ui-helpers/types.ts';
import { HeadingStatus } from 'ewi-ui/components/1-atoms/Heading/Heading.vue';

export interface FooterContactItemProps {
  id?: string;
  icon?: string;
  heading?: string;
  headingStatus?: HeadingStatus;
  paragraph?: string;
  paragraphPopover?: string;
  textHorizontalAlignment?: string;
  textVerticalAlignment?: string;
  buttonContent?: string;
  buttonStyle?: ButtonType;
  buttonLink?: string;
  buttonTarget?: '_self' | '_blank';
  buttonCustomClass?: string;
  secondParagraph?: string;
  secondParagraphPopover?: string;
  secondButtonContent?: string;
  secondButtonStyle?: ButtonType;
  secondButtonLink?: string;
  secondButtonCustomClass?: string;
  secondButtonTarget?: '_self' | '_blank';
}

const props = withDefaults(defineProps<FooterContactItemProps>(), {
  id: '',
  icon: 'leaf',
  heading: '',
  headingStatus: '',
  paragraph: '',
  paragraphPopover: '',
  textHorizontalAlignment: 'center',
  textVerticalAlignment: '',
  buttonContent: '',
  buttonStyle: 'outlined',
  buttonLink: '#',
  buttonTarget: '_self',
  buttonCustomClass: '',
  secondParagraph: '',
  secondParagraphPopover: '',
  secondButtonContent: '',
  secondButtonStyle: 'outlined',
  secondButtonLink: '#',
  secondButtonCustomClass: '',
  secondButtonTarget: '_self',
});

const classes = computed(() => ({
  'footer-contact-item': true,
  [`text-horizontal-align-${props.textHorizontalAlignment}`]:
    props.textHorizontalAlignment !== '',
  [`text-vertical-align-${props.textVerticalAlignment}`]:
    props.textVerticalAlignment !== '',
}));

const verticalAlignClass = computed(() => ({
  [`text-vertical-align-${props.textVerticalAlignment}`]:
    props.textVerticalAlignment !== '',
}));
</script>
